import React from 'react';
import './DailyTimesheetForm.scss';
import DailyTimesheetDetail from './DailyTimesheetDetail';
import AddDailyTimesheetDetailButton from './AddDailyTimesheetDetailButton';
import { Input, InputGroup, Table } from 'reactstrap';
import { calculateTimesheetElapsedHours } from './DailyTimesheet';
import CrewTimesheetStatusRow from '../crewTimesheet/CrewTimesheetStatusRow';
import { FormLabel } from '../common/forms/FormElements';

export default class DailyTimesheetDetails extends React.Component {
    getDetailKey = (dailyTimesheetDetail) =>
        `dtd-${dailyTimesheetDetail.id}-${dailyTimesheetDetail.contractId}-${dailyTimesheetDetail.contractPhaseId}`;

    onNotesChange = (e) => {
        const { dailyTimesheet, onDailyTimesheetMutated } = this.props;

        dailyTimesheet.notes = e.target.value;

        onDailyTimesheetMutated(dailyTimesheet);
    };

    render() {
        const { dailyTimesheet, readOnly, isAdmin } = this.props;

        const totalElapsedHours =
            calculateTimesheetElapsedHours(dailyTimesheet);

        return (
            <div className="daily-timesheet-details">
                {!readOnly && (
                    <div className="mb-2">
                        <AddDailyTimesheetDetailButton {...this.props} />
                    </div>
                )}

                {(readOnly || isAdmin) && (
                    <CrewTimesheetStatusRow
                        {...this.props}
                        timesheet={dailyTimesheet}
                        isAdmin={!dailyTimesheet.createdByCurrentUser}
                    />
                )}

                <div className="table-responsive daily-timesheet-table">
                    <Table striped={true}>
                        <thead>
                            <tr>
                                <th width="25%">Job</th>
                                <th width="25%">Phase</th>
                                <th width="15%">Start Time</th>
                                <th width="15%">End Time</th>
                                <th width="10%">Hours Worked</th>
                                <th width="10%"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {dailyTimesheet.dailyTimesheetDetails.length == 0 && (
                                <tr>
                                    <td colSpan={6}>Please select a job</td>
                                </tr>
                            )}

                            {dailyTimesheet.dailyTimesheetDetails.map((dtd) => (
                                <DailyTimesheetDetail
                                    key={this.getDetailKey(dtd)}
                                    dailyTimesheetDetail={dtd}
                                    {...this.props}
                                />
                            ))}
                        </tbody>
                        {dailyTimesheet.dailyTimesheetDetails.length > 0 && (
                            <tfoot>
                                <tr>
                                    <td colSpan={4}></td>
                                    <td className="font-weight-bold">
                                        Total: {totalElapsedHours} hrs
                                    </td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        )}
                    </Table>
                </div>

                <div>
                    <InputGroup>
                        <FormLabel text="Notes" className="mr-2" />

                        <Input
                            type="textarea"
                            value={dailyTimesheet.notes}
                            maxLength={500}
                            length={500}
                            onChange={this.onNotesChange}
                            readOnly={readOnly}
                        />
                    </InputGroup>
                </div>
            </div>
        );
    }
}

